import Api from "./Api";

export const PerformanceBookingService = {

    getPerformanceBookingsByVenue: async (venueId) => {

        const res = await Api.get(`/perform-at-utsya?venueId=${venueId}`);

        return res.data;

    }

};